var hashtag_default = {
  "fontElementMap": "du4nv",
  "hashtag": "fJrGn"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
